import React from 'react';

const VerticalSeparator = (props) => {
    return (
        <div style={{ height: props.height }}></div>
    );
}

const LineSeparator = () => {
    return (
        <hr style={{ borderTop: '3px solid #000' }} />
    );
}

export {VerticalSeparator, LineSeparator};